import { Button } from '@/components/ui/button';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '@/components/ui/input-otp';
import { cn, getErrorBorderClass } from '@/lib';
import { Link } from 'react-router-dom';

export type BusinessVerificationFormProps = React.ComponentProps<'div'> & {
  email: string;
  codeDestination: string | null;
  otpValue: string;
  isLoading: boolean;
  hasError?: boolean;
  resendCountdown: number;
  onOtpChange: (value: string) => void;
  onSubmitOtp: () => void;
  onResendOtp: () => void;
  onChangeEmail: () => void;
};

export function BusinessVerificationForm({
  className,
  email,
  codeDestination,
  otpValue,
  isLoading,
  hasError,
  resendCountdown,
  onOtpChange,
  onSubmitOtp,
  onResendOtp,
  onChangeEmail,
  ...props
}: BusinessVerificationFormProps) {
  return (
    <div className={cn('flex flex-col gap-6', className)} {...props}>
      <div className="flex flex-col items-center gap-2 text-center">
        <h1 className="text-2xl font-bold">Verify your email</h1>
        <p className="text-muted-foreground text-sm text-balance">
          We sent a 6-digit code to {codeDestination || email}
        </p>
      </div>

      <div className="grid gap-6">
        <div className="grid gap-3">
          <div className="flex justify-center">
            <InputOTP maxLength={6} value={otpValue} onChange={onOtpChange} className={getErrorBorderClass(hasError)}>
              <InputOTPGroup>
                <InputOTPSlot index={0} />
                <InputOTPSlot index={1} />
                <InputOTPSlot index={2} />
                <InputOTPSlot index={3} />
                <InputOTPSlot index={4} />
                <InputOTPSlot index={5} />
              </InputOTPGroup>
            </InputOTP>
          </div>
        </div>

        <Button type="button" className="w-full" disabled={isLoading || otpValue.length !== 6} onClick={onSubmitOtp}>
          {isLoading ? 'Verifying...' : 'Verify code'}
        </Button>

        <div className="text-center text-sm">
          {resendCountdown > 0 ? (
            <p className="text-muted-foreground">Resend code in {resendCountdown}s</p>
          ) : (
            <button type="button" onClick={onResendOtp} className="text-primary hover:underline" disabled={isLoading}>
              Resend code
            </button>
          )}
        </div>

        <div className="flex justify-center gap-4 text-sm">
          <Link to="/login" state={{ email }} className="text-primary hover:underline">
            Sign in
          </Link>
          <Link to="/forgot-password" state={{ email }} className="text-primary hover:underline">
            Reset password
          </Link>
        </div>

        <div className="text-center text-sm">
          <button type="button" onClick={onChangeEmail} className="text-muted-foreground hover:underline">
            Change email address
          </button>
        </div>
      </div>
    </div>
  );
}
